import { render, staticRenderFns } from "./drawerChatEdit.vue?vue&type=template&id=77bdc178&"
import script from "./drawerChatEdit.vue?vue&type=script&lang=js&"
export * from "./drawerChatEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports